import React, { useEffect, useState } from "react";
import { Input, Icon } from "antd";
import DatePicker from "react-mobile-datepicker";
import config from "appConfig";
import moment from "moment";
import {
  parseFormControlValue,
  checkEmptyObject
} from "../../../services/utils";
import { InputType } from "../../../models";

import styles from "./datePickerMobile.scss";

let format = "";

const DatePickerMobile = props => {
  const {
    isRequired,
    title,
    placeholder,
    isDisabled,
    className,
    max,
    min,
    disabledDate
  } = props;

  const [open, setOpen] = useState(false);
  const [pickerValue, setPickerValue] = useState(undefined);
  const [inputValue, setInputValue] = useState("");
  const [configs, setConfigs] = useState({});

  useEffect(() => {
    const { value, field } = props;

    let formValue: any;
    let pickerValue: any;
    if (checkEmptyObject(value)) {
      formValue = field ? value[field] : value;
      pickerValue = new Date(formValue);
    }

    const configs = createDateConfigs();
    const inputValue = formValue && moment(formValue).format(format);

    setPickerValue(pickerValue);
    setInputValue(inputValue);
    setConfigs(configs);
  }, []);

  const createDateConfigs = () => {
    const { controlType, dateConfigs } = props;
    let configs: any = {};

    switch (controlType) {
      case InputType.year:
        configs.year = dateConfigs.year;
        format = config.yearFormat;
        break;

      case InputType.month:
        configs.month = dateConfigs.month;
        configs.year = dateConfigs.year;
        format = config.monthFormat;
        break;

      default:
        configs = dateConfigs;
        format = config.dateFormat;
        break;
    }

    return configs;
  };

  const handlePickerOpen = () => {
    setOpen(true);
  };

  const handlePickerClose = () => {
    setOpen(false);
  };

  const handleOk = dateObject => {
    const { onChange, field, controlType } = props;
    const momentDate = moment(dateObject);
    const inputValue = momentDate.format(format);
    setOpen(false);
    setInputValue(inputValue);
    setPickerValue(dateObject);

    if (!field) {
      onChange(momentDate, inputValue);
      return;
    }

    const date = moment.utc({ year: dateObject.getFullYear() });

    switch (controlType) {
      case InputType.year:
        // set the date at middle of year
        date.month(5);
        break;

      case InputType.month:
        // set the date at middle of month
        date.month(dateObject.getMonth());
        date.date(15);
        break;

      case InputType.date:
        // set the time at middle of date
        date.month(dateObject.getMonth());
        date.date(dateObject.getDate());
        date.hour(12);
        break;

      default:
        throw new Error("Unsupported control type");
    }

    onChange(parseFormControlValue([field], [date.toISOString()]));
  };

  return (
    <div className={className}>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
      <Input
        onClick={handlePickerOpen}
        value={inputValue}
        size="large"
        readOnly
        placeholder={placeholder}
        disabled={isDisabled}
        className={styles.input}
      />
      <DatePicker
        value={pickerValue}
        dateConfig={configs}
        isOpen={open}
        onCancel={handlePickerClose}
        confirmText={"Primjeni"}
        cancelText={"Otkaži"}
        // onChange={handleChange}
        onSelect={handleOk}
        showHeader
        customHeader={
          <div>
            {title}
            <Icon type="close" onClick={handlePickerClose} />
          </div>
        }
        max={max}
        min={min}
        disabledDate={disabledDate}
      />
    </div>
  );
};

DatePickerMobile.defaultProps = {
  dateConfigs: {
    date: {
      format: "DD",
      step: 1
    },
    month: {
      format: "MM",
      step: 1
    },
    year: {
      format: "YYYY",
      step: 1
    }
  },
  title: "",
  isRequired: false,
  controlType: InputType.date,
  placeholder: "",
  isDisabled: false,
  className: "",
  max: undefined,
  min: undefined,
  field: ""
};

export default DatePickerMobile;



// WEBPACK FOOTER //
// ./src/components/FormControls/DatePickerMobile/index.tsx